export enum MessageType {
  Success = "success",
  Error = "error",
  Warning = "warning",
  Info = "info"
}
